import Vue from 'vue'
import App from './App.vue';
import router from './router';
import Vuex from 'vuex'
import store from './store/store.js';

import 'onsenui/css/onsenui-core.min.css';
import 'onsenui/css/onsen-css-components.css';

import VueOnsen from 'vue-onsenui';

import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/swiper-bundle.css';
import Ripple from 'vue-ripple-directive'

import 'dayjs/locale/ja'
import dayjs from 'dayjs'
import sanitizeHtml from 'sanitize-html';

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.use(VueOnsen);
Vue.use(VueAwesomeSwiper);
Vue.use(Vuex);
Vue.use(VueLoading);


Vue.config.productionTip = false
Vue.config.devtools = true;

Ripple.color = 'rgba(254, 107, 1, 0.25)';
Ripple.zIndex = 55;
Vue.directive('ripple', Ripple);

// サニタイズHTML関数で許可するHTMLタグを定義
let allowedTags = [
//  'h2',
//  'h3',
//  'h4',
//  'blockquote',
//  'p',
//  'span',
  'a',
//  'ul',
//  'ol',
//  'li',
//  'b',
//  'i',
//  'strong',
//  'em',
//  'strike',
//  'u',
//  's',
//  'code',
//  'hr',
  'br',
//  'div',
//  'table',
//  'thead',
//  'caption',
//  'tbody',
//  'tr',
//  'th',
//  'td',
//  'pre',
//  'iframe',
//  'img'
];

// サニタイズHTMLの許可タグを設定する
let defaults = sanitizeHtml.defaults;
defaults.allowedTags = allowedTags;
defaults.allowedAttributes = false;
Vue.prototype.$sanitize = sanitizeHtml;

new Vue({
  router,
  store,
  render: h => h(App),
  beforeCreate() {
    this.$ons.disableAutoStyling(); // Or any other method
  }
}).$mount('#app')
